import ListTemplate from "components/ListTemplate";
import React from "react";
import Filters from "./Filters";
import { AddTagsModal, ChangeOwnerModal, ChangeStatusModal, ReplaceTagsModal, BatchDeleteModal } from "components/Tables/MySelection/Modals";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const ContactListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ContactListFrontModel>();

  return <ListTemplate
    title={RESX.Contact.Contacts}
    filterSet="contact_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Contact.Paginated}
    getId={item => item.contactId}
    layout={cardLayout(viewModel)}
    filters={<Filters initialStatuses={viewModel.statuses} initialTags={viewModel.tags} />}
    functions={{
      mapFilterValuesToInstruction,
      mapResponseToFilterValues
    }}
    options={{
      filterPreset: {
        cacheKey: "contact_List",
        listApi: window.CoreApi.FilterPreset.ListFilterPresetsForContact,
        mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForContact
      },
      exportOptions: {
        canExportList: site.permissions.addressBook.canExportList,
        exportOptionsApi: window.CoreApi.Contact.ExportOptionsForList
      },
      mySelection: {
        isSelected: item => item.isSelected,
        mainArea: "contact",
        batchActions: [{
          label: RESX.Status.ChangeStatus,
          modal: ChangeStatusModal,
          props: { statuses: viewModel.statuses }
        }, {
          label: RESX.Tag.ReplaceTags,
          modal: ReplaceTagsModal,
          props: { tags: viewModel.tags }
        }, {
          label: RESX.Tag.AddTags,
          modal: AddTagsModal,
          props: { tags: viewModel.tags }
        }, {
          label: RESX.Planning.ChangeOwner,
          modal: ChangeOwnerModal
        }, {
          label: RESX.Buttons.btnDeleteAll,
          modal: BatchDeleteModal
        }]
      }
    }}
  />;
};

export default ContactListApp;
